export interface ValidationErrorResponse {
    [field: string]: string
}

export default class ValidationError extends Error {
    failedValidations: ValidationErrorResponse;

    constructor(failedValidations: ValidationErrorResponse) {
        super('Failed validations');

        this.failedValidations = failedValidations;

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ValidationError.prototype);
    }

    getFailedValidations() {
        return this.failedValidations;
    }
}